import Config from "src/Constants/Config";

import setCurrentPage from "src/Utils/setCurrentPage";

import store from "src/Reducers/store";
import { useSelector } from "react-redux";

import { Audios } from "@yamildiego/presentation-kit";

const PageId = 301;
const PreviousPageId = 1;
const NextPageId = PageId + 1;

const DATA_INTRO = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const muted = useSelector(() => store.getState().appReducer.muted);
  const audioSrc = `${Config.BASE_URL}/audios/employee_onboarding/PRCX_18_Employee Onboarding - ${PageId}.mp3`;

  return {
    bgImage: `${Config.BASE_URL}/images/employee_onboarding/bg_1.png`,
    title: "Introduction",
    text: `Meet Emma, the newest addition to the call\ncentre team at Probe CX, bringing her skills\nand positive energy to elevate customer\nservice. She's excited to get started!`,
    rightSideImage: {
      image: `${Config.BASE_URL}/images/employee_onboarding/vanessa_intro.png`,
      style: { top: "-11.8125rem", width: "43.5rem", left: "40rem" },
    },
    back: { label: "Go Back", type: "back", startIcon: "arrow-left", onClick: () => setCurrentPage(PreviousPageId) },
    next: { label: "Continue", type: "next", endIcon: "arrow-right", onClick: () => setCurrentPage(NextPageId) },
    audio: <Audios muted={muted} pageNumber={PageId} currentPage={currentPage} audios={[{ src: audioSrc, timer: 0 }]} />,
  };
};

export default DATA_INTRO;
